import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { translate, TranslocoService } from '@ngneat/transloco';
import { requiresSalesContact } from 'src/app/plan-workers';

declare var require: any;
declare var $: any;
import * as _ from 'lodash-es';

@Component({
  selector: 'app-account-plan',
  templateUrl: './plan.component.html',
  styleUrls: ['./plan.component.scss']
})
export class PlanComponent implements OnInit {


  form:any;
  submitted = false;

  plan:any = null;
  updated_plan = false;

  workers:any = null;
  call_plan_pricing:any = null;
  monitoring_pricing:any = null;

  sending = false;

  hide_contract_form:any = null;

  pricing:any = null;
  contract:any = null;
  is_live:any = null;
  account_type:any = null;
  loading = true;
  upsell_done = false;
  worker_reduction_message = '';

  showSalesContact = false;
  salesContactSending = false;
  salesContactSent = false;
  pendingSalesWorkers: number | null = null;

  tab_view='pricing';

  
  lm_options= [
    {"val":true,"txt":"Use Call Centre"},
    {"val":false,"txt":"No Call Centre"},
  ];

  call_options= [
    {"val":true,"txt":"Use Comms Plan"},
    {"val":false,"txt":"App Only"},
  ];

  show_image = false;

  new_pricing = false;

  worker_counts:any = [];

  /** The contracted per-worker rate from the server. Set once in livePlan() and never changed. */
  contractedPerWorker: number = 0;

  constructor(public okService: OkAloneService, private transloco: TranslocoService) {

  }

  ngOnInit(): void {
    this.getContract();
  }

  getContract(){
    this.okService.get('billing/contract',{})
    .subscribe((response:any) => {

      let data = response.body;
      //console.log(data);

      if(data['contract']){


        this.contract = data['contract'];
        this.hide_contract_form = this.contract.hide_contract_form;
        this.is_live = this.contract.is_live;
        this.account_type = this.contract.account_type;
        this.new_pricing = this.contract.new_pricing;

        this.setPricing();

        //console.log("plan");
        //console.log(this.contract);

        if(!this.hide_contract_form && (this.account_type=="Standard" || this.account_type=="WorkerPlan")){

          this.form = new FormGroup({
            workers : new FormControl(this.contract.max_workers, [Validators.required]),	
            currency : new FormControl(this.contract.currency, [Validators.required]),	
            monitoring : new FormControl((this.contract.live_monitoring==1), [Validators.required]),	
            call_plan : new FormControl((this.contract.call_plan==1), [Validators.required]),	
    
          });
          
  
          //console.log(this.form.value);
          this.loading = false;
          this.livePlan();
        }else{
          this.loading = false;
        }

      }


    });

    
  }





  

  tabView(view:string){
    this.tab_view = view;
  }



get f() { return this.form.controls; }

livePlan(){
  this.setPricing();

  this.contractedPerWorker = (this.contract.per_worker && +this.contract.per_worker > 0)
    ? +this.contract.per_worker
    : this.contract.fee / this.contract.max_workers;

  this.plan = {
  "workers":this.contract.max_workers,
  "label":"Up to "+this.contract.max_workers+" workers",
  "per_worker":this.dec2(this.contractedPerWorker),
  "subscription":this.dec2(this.contract.fee),
  "live_monitoring":this.contract.live_monitoring,
  "live_monitoring_minutes":this.dec2(this.contract.live_monitoring_minutes),
  "live_monitoring_fee":this.dec2(this.contract.live_monitoring_fee),
  "call_plan":this.contract.call_plan,
  "call_plan_inc":this.dec2(this.contract.call_plan_included),
  "call_plan_cost":this.dec2(this.contract.call_plan_cost),
  "extra_call_mins":0.1
  }

  this.plan.currency = this.form.value.currency;

  this.calcTotal();

}

getPlan(){

  if (requiresSalesContact(+this.form.value.workers)) {
    return;
  }

  this.setPricing();

  const newWorkers = +this.form.value.workers;

  this.plan.workers = newWorkers;
  this.plan.per_worker = this.dec2(this.contractedPerWorker);
  this.plan.subscription = this.dec2(this.contractedPerWorker * newWorkers);

  if(!this.is_live){

    let old_call_plan_cost = null;

    // Keep existing sms cost if it is already set
    if(this.plan.call_plan_cost > 0 && this.plan.call_plan_cost <= 2){
      old_call_plan_cost = this.plan.call_plan_cost;
    }

    if(this.account_type == "WorkerPlan"){

      // Use getWorkerPricing only for add-on rates (lm / sms), NOT for per_worker or subscription.
      let addonRates = this.getWorkerPricing(this.form.value.currency, newWorkers);

      if(this.form.value.monitoring){
        this.plan = _.merge(this.plan,{'live_monitoring':1,'live_monitoring_fee':addonRates.lm,'live_monitoring_inc':0});
      }

      if(this.form.value.call_plan){
        if(old_call_plan_cost){
          this.plan = _.merge(this.plan,{'call_plan':1,'call_plan_cost':old_call_plan_cost,'call_plan_inc':0});
        }else{
          this.plan = _.merge(this.plan,{'call_plan':1,'call_plan_cost':addonRates.sms,'call_plan_inc':0});
        }
      }

    }else{

      this.plan = _.merge(this.plan,{'live_monitoring':1});
      this.plan = _.merge(this.plan,{'call_plan':1});

    }

    if(!this.form.value.monitoring){
      this.plan = _.merge(this.plan,{'live_monitoring_minutes':0,'live_monitoring_fee':0,'extra_mins':0});
    }

    if(!this.form.value.call_plan){
      this.plan = _.merge(this.plan,{'call_plan':0,'call_plan_inc':0,'call_plan_cost':0,'extra_call_mins':0});
    }

  }

  this.calculatePlan();
}

calcTotal(){
  //console.log(this.plan);
  if(this.account_type=="WorkerPlan"){
    this.plan.total = this.dec2(+this.plan.subscription +  +this.plan.live_monitoring_fee*this.plan.workers + +this.plan.call_plan_cost*this.plan.workers);
  }else{
    this.plan.total = this.dec2(+this.plan.subscription +  +this.plan.live_monitoring_fee + +this.plan.call_plan_cost);
  
  }
  //console.log(this.plan);
}

calculatePlan(){

  this.plan.currency = this.form.value.currency;

  // per_worker is always the contracted rate — never derived from subscription / workers.
  this.plan.per_worker = this.dec2(this.contractedPerWorker);

  this.calcTotal();

  // Only convert USD prices to £ for non-live Standard accounts using the pricing table.
  // Live accounts already have all prices stored in their contracted currency — do not convert.
  if(!this.is_live && this.account_type == "Standard"){
    if(this.plan['currency']=="£"){
      let poundValue = 0.8;
      this.plan['subscription']=this.dec0(+this.plan['subscription']*poundValue);
      this.plan['live_monitoring_fee']=this.dec0(+this.plan['live_monitoring_fee']*poundValue);
      this.plan['call_plan_cost']=this.dec0(+this.plan['call_plan_cost']*poundValue);
      this.plan['extra_call_mins']=this.dec2(+this.plan['extra_call_mins']*poundValue);
      this.plan['extra_mins']=this.dec2((+this.plan['extra_mins']||0)*poundValue);
      this.plan['per_worker']=this.dec2(this.contractedPerWorker*poundValue);
      this.plan['total']=this.dec2(+this.plan['total']*poundValue);
    }
  }

  //console.log("currency",this.plan);
}

submit(){

  //console.log(this.monitoring_pricing);
  
  this.submitted = true;

  //console.log("submit");

  let fields = this.form.value;
  
  if (this.form.invalid) {

    //console.log(this.f);

    //console.log("Failed form");
    return;
  }

  if (requiresSalesContact(+fields.workers)) {
    return;
  }

  //console.log(this.monitoring_pricing);
  this.updated_plan = true;
  this.getPlan();


  return;
}

savePlan(){

  if (requiresSalesContact(+this.plan.workers)) {
    return;
  }

  this.sending = true;
  //console.log({plan:this.plan});

  this.okService.put('billing/contract',{plan:this.plan})
  .subscribe((data) => {

    //console.log(data);

    //window.location.reload();

    this.setPricing();
    this.getContract();
    this.sending = false;



  }); 


}


dec2(num:any){
  if(num % 1 === 0){
      return +parseFloat(num).toFixed(0);
  }
  return (Math.round(num * 100) / 100).toFixed(2);
}

dec0(num:any){
  return parseFloat(String(Math.round(num * 100) / 100)).toFixed(0);
}



getWorkerPricing(currency:string,workers:number){

  let pricingData:any = [];

  //console.log(this.plan);

  if(this.plan.per_worker > 8){

    pricingData = [
      {'currency':'£','per_worker':7,'lm':5,'sms':5},
      {'currency':'US$','per_worker':10,'lm':5,'sms':5},
      {'currency':'$','per_worker':10,'lm':5,'sms':5},
      {'currency':'GBP £','per_worker':7,'lm':5,'sms':5},
      {'currency':'USD $','per_worker':10,'lm':5,'sms':5},
      {'currency':'CAD $','per_worker':10,'lm':5,'sms':5},
    ];

  }else{

    pricingData = [
      {'currency':'£','per_worker':7,'lm':9,'sms':4},
      {'currency':'US$','per_worker':8,'lm':10,'sms':4},
      {'currency':'$','per_worker':8,'lm':10,'sms':4},
      {'currency':'GBP £','per_worker':7,'lm':9,'sms':4},
      {'currency':'USD $','per_worker':8,'lm':10,'sms':4},
      {'currency':'CAD $','per_worker':8,'lm':10,'sms':4},
    ];

  }

  let plan =  _.find(pricingData, { 'currency': currency });

  if(!plan){
    if(this.plan.per_worker > 8){
      plan = {'currency':'US$','per_worker':10,'lm':5,'sms':5};
    }else{
      plan = {'currency':'US$','per_worker':8,'lm':5,'sms':4};
    }
  }

  plan.workers = workers;

  return plan;
    
}

setPricing(){

  let pricing = [
    {"workers":5,"label":"1 - 5 workers","per_worker":5,"subscription":25,"live_monitoring_minutes":5,"live_monitoring_fee":30,"call_plan_inc":100,"call_plan_cost":10,"extra_call_mins":0.1},
    {"workers":10,"label":"Up to 10 workers","per_worker":4.9,"subscription":49,"live_monitoring_minutes":7,"live_monitoring_fee":42,"call_plan_inc":200,"call_plan_cost":20,"extra_call_mins":0.1},
    {"workers":15,"label":"Up to 15 workers","per_worker":4.9,"subscription":73.5,"live_monitoring_minutes":9,"live_monitoring_fee":54,"call_plan_inc":300,"call_plan_cost":30,"extra_call_mins":0.1},
    {"workers":20,"label":"Up to 20 workers","per_worker":4.9,"subscription":98,"live_monitoring_minutes":10,"live_monitoring_fee":60,"call_plan_inc":400,"call_plan_cost":40,"extra_call_mins":0.1},
    {"workers":25,"label":"Up to 25 workers","per_worker":4.6,"subscription":115,"live_monitoring_minutes":10,"live_monitoring_fee":60,"call_plan_inc":500,"call_plan_cost":50,"extra_call_mins":0.1},
    {"workers":30,"label":"Up to 30 workers","per_worker":4.6,"subscription":138,"live_monitoring_minutes":12,"live_monitoring_fee":72,"call_plan_inc":600,"call_plan_cost":60,"extra_call_mins":0.1},
    {"workers":35,"label":"Up to 35 workers","per_worker":4.6,"subscription":161,"live_monitoring_minutes":12,"live_monitoring_fee":72,"call_plan_inc":700,"call_plan_cost":70,"extra_call_mins":0.1},
    {"workers":40,"label":"Up to 40 workers","per_worker":4.6,"subscription":184,"live_monitoring_minutes":15,"live_monitoring_fee":90,"call_plan_inc":800,"call_plan_cost":80,"extra_call_mins":0.1},
    {"workers":45,"label":"Up to 45 workers","per_worker":4.6,"subscription":207,"live_monitoring_minutes":15,"live_monitoring_fee":90,"call_plan_inc":900,"call_plan_cost":90,"extra_call_mins":0.1},
    {"workers":50,"label":"Up to 50 workers","per_worker":4.5,"subscription":225,"live_monitoring_minutes":17,"live_monitoring_fee":93.5,"call_plan_inc":1000,"call_plan_cost":100,"extra_call_mins":0.1},
    {"workers":60,"label":"Up to 60 workers","per_worker":4.5,"subscription":270,"live_monitoring_minutes":17,"live_monitoring_fee":93.5,"call_plan_inc":1200,"call_plan_cost":120,"extra_call_mins":0.1},
    {"workers":70,"label":"Up to 70 workers","per_worker":4.5,"subscription":315,"live_monitoring_minutes":20,"live_monitoring_fee":110,"call_plan_inc":1400,"call_plan_cost":140,"extra_call_mins":0.1},
    {"workers":80,"label":"Up to 80 workers","per_worker":4.5,"subscription":360,"live_monitoring_minutes":20,"live_monitoring_fee":110,"call_plan_inc":1600,"call_plan_cost":160,"extra_call_mins":0.1},
    {"workers":90,"label":"Up to 90 workers","per_worker":4.5,"subscription":405,"live_monitoring_minutes":22,"live_monitoring_fee":121,"call_plan_inc":1800,"call_plan_cost":180,"extra_call_mins":0.1},
    {"workers":100,"label":"Up to 100 workers","per_worker":4.25,"subscription":425,"live_monitoring_minutes":22,"live_monitoring_fee":121,"call_plan_inc":2000,"call_plan_cost":200,"extra_call_mins":0.1},
    {"workers":110,"label":"Up to 110 workers","per_worker":4.25,"subscription":467.5,"live_monitoring_minutes":25,"live_monitoring_fee":137.5,"call_plan_inc":2200,"call_plan_cost":220,"extra_call_mins":0.1},
    {"workers":120,"label":"Up to 120 workers","per_worker":4.25,"subscription":510,"live_monitoring_minutes":25,"live_monitoring_fee":137.5,"call_plan_inc":2400,"call_plan_cost":240,"extra_call_mins":0.1},
    {"workers":130,"label":"Up to 130 workers","per_worker":4.25,"subscription":552.5,"live_monitoring_minutes":25,"live_monitoring_fee":137.5,"call_plan_inc":2600,"call_plan_cost":260,"extra_call_mins":0.1},
    {"workers":140,"label":"Up to 140 workers","per_worker":4.25,"subscription":595,"live_monitoring_minutes":25,"live_monitoring_fee":137.5,"call_plan_inc":2800,"call_plan_cost":280,"extra_call_mins":0.1},
    {"workers":150,"label":"Up to 150 workers","per_worker":4.15,"subscription":622.5,"live_monitoring_minutes":25,"live_monitoring_fee":125,"call_plan_inc":3000,"call_plan_cost":300,"extra_call_mins":0.1},
    {"workers":160,"label":"Up to 160 workers","per_worker":4.15,"subscription":664,"live_monitoring_minutes":27,"live_monitoring_fee":135,"call_plan_inc":3200,"call_plan_cost":320,"extra_call_mins":0.1},
    {"workers":170,"label":"Up to 170 workers","per_worker":4.15,"subscription":705.5,"live_monitoring_minutes":27,"live_monitoring_fee":135,"call_plan_inc":3400,"call_plan_cost":340,"extra_call_mins":0.1},
    {"workers":180,"label":"Up to 180 workers","per_worker":4.15,"subscription":747,"live_monitoring_minutes":27,"live_monitoring_fee":135,"call_plan_inc":3600,"call_plan_cost":360,"extra_call_mins":0.1},
    {"workers":190,"label":"Up to 190 workers","per_worker":4.15,"subscription":788.5,"live_monitoring_minutes":27,"live_monitoring_fee":135,"call_plan_inc":3800,"call_plan_cost":380,"extra_call_mins":0.1},
    {"workers":200,"label":"Up to 200 workers","per_worker":4.15,"subscription":830,"live_monitoring_minutes":30,"live_monitoring_fee":150,"call_plan_inc":4000,"call_plan_cost":400,"extra_call_mins":0.1},
    {"workers":250,"label":"Up to 250 workers","per_worker":4.15,"subscription":1037.5,"live_monitoring_minutes":32,"live_monitoring_fee":160,"call_plan_inc":5000,"call_plan_cost":500,"extra_call_mins":0.1},
    {"workers":300,"label":"Up to 300 workers","per_worker":4.08,"subscription":1224,"live_monitoring_minutes":35,"live_monitoring_fee":175,"call_plan_inc":6000,"call_plan_cost":600,"extra_call_mins":0.1},
    {"workers":350,"label":"Up to 350 workers","per_worker":4.08,"subscription":1428,"live_monitoring_minutes":37,"live_monitoring_fee":185,"call_plan_inc":7000,"call_plan_cost":700,"extra_call_mins":0.1},
    {"workers":400,"label":"Up to 400 workers","per_worker":4.08,"subscription":1632,"live_monitoring_minutes":40,"live_monitoring_fee":200,"call_plan_inc":8000,"call_plan_cost":800,"extra_call_mins":0.1},
    {"workers":450,"label":"Up to 450 workers","per_worker":4.08,"subscription":1836,"live_monitoring_minutes":45,"live_monitoring_fee":225,"call_plan_inc":9000,"call_plan_cost":900,"extra_call_mins":0.1},
    {"workers":500,"label":"Up to 500 workers","per_worker":4.05,"subscription":2025,"live_monitoring_minutes":50,"live_monitoring_fee":250,"call_plan_inc":10000,"call_plan_cost":1000,"extra_call_mins":0.1},
    
           
];


  if(this.account_type=="WorkerPlan"){

    
  }



  if(this.is_live){
    let max_workers = this.contract.max_workers;
    _.remove(pricing, function(n:any) {
      return n.workers < max_workers;
    });


  }

  

  this.pricing = pricing;

  let self = this;
  _.forEach(pricing, function(value:any) {
    self.worker_counts.push(value.workers)
  });
  //console.log(this.worker_counts);

  

}



upsellSmsCall(){

  let x = this.form.value.workers;
  let closest = this.worker_counts.sort( (a:any, b:any) => Math.abs(x - a) - Math.abs(x - b) )[0];

  //console.log("closest",closest);

  let sms_plan = null;


  if(this.account_type=="WorkerPlan"){

    
    let plan = this.getWorkerPricing(this.plan.currency,closest)
    let sms_plan = {'call_plan':1,'call_plan_cost':plan.sms,'call_plan_inc':0};
    //console.log("sms_plan",sms_plan);
    this.plan = _.merge(this.plan,sms_plan);
    //console.log("sms_plan",sms_plan);

  }else{
    let plan = _.find(this.pricing,{'workers':+closest});
    let sms_plan = {'call_plan':1,'call_plan_inc':plan.call_plan_inc,'call_plan_cost':plan.call_plan_cost,'extra_call_mins':plan.extra_call_mins};
    this.plan = _.merge(this.plan,sms_plan);

  }
  

  //console.log("upsellSmsCall",this.plan);
  

  this.upsell_done = true;
  this.calculatePlan();
  this.updated_plan = true;
}

upsellSmsCallCancel(){
  this.plan = _.merge(this.plan,{'call_plan':0,'call_plan_inc':0,'call_plan_cost':0,'extra_call_mins':0,'sms':0,'sms_total':0});
  this.upsell_done = false;
  this.calculatePlan();
  this.updated_plan = true;
}

changeWorkers(){
  // Clear any previous message
  this.worker_reduction_message = '';

  const workers = +this.form.value.workers;

  if (requiresSalesContact(workers)) {
    this.showSalesContact = true;
    this.pendingSalesWorkers = workers;
    this.salesContactSent = false;
    this.form.patchValue({workers: this.plan.workers});
    return;
  }

  this.clearSalesContact();

  // Check if trying to reduce workers on a live plan (including on hold)
  if(!this.okService.billing.trial_active){

    if(this.form.value.workers < this.plan.workers && !this.updated_plan){
      this.worker_reduction_message = 'To reduce your plan, please email <a href="mailto:customer.support@ok-alone.com">customer.support&#64;ok-alone.com</a>';
      // Reset the form value to the current plan workers to prevent the reduction
      this.form.patchValue({workers: this.plan.workers});
      return;
    }

  }

  if(this.is_live){

      this.submit();

  }else{

    if(this.form.value.workers < 20){
      this.form.patchValue({monitoring: false});
    }

  }
}

clearSalesContact(){
  this.showSalesContact = false;
  this.pendingSalesWorkers = null;
  this.salesContactSent = false;
}

confirmSalesContact(){
  this.salesContactSending = true;

  this.okService.post('billing/sales-request', {
    requested_workers: this.pendingSalesWorkers,
    is_live: !!this.is_live,
    account_type: this.account_type,
    current_workers: +this.plan.workers,
  }).subscribe({
    next: () => {
      this.salesContactSending = false;
      this.salesContactSent = true;
    },
    error: () => {
      this.salesContactSending = false;
    },
  });
}
}
